export const updateName = (firstName, middleName, lastName) => ({
  type: "UPDATE_NAME", 
  payload: {
    firstName,
    middleName,
    lastName
  }
});

export const updateBirthdate = (date) => ({
  type:"UPDATE_BIRTHDATE",
  date
});

//PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
export const updateContact = (email, mobilePhone, homePhone, accountPassword) => ({
  type:"UPDATE_CONTACT",
  payload: {
    email, mobilePhone, homePhone, accountPassword
  }
});

export const updateAddress = (address1, address2, city, province, postalCode, manualEntry, individuallySet = false) => ({
  type: "UPDATE_ADDRESS",
  payload: {
    address1,
    address2,
    city,
    province,
    postalCode,
    manualEntry,
    individuallySet
  }
});

export const updateMailingAddress = (address1, address2, city, province, postalCode, individuallySet = false) => ({
  type: "UPDATE_MAILING_ADDRESS",
  payload: {
    address1,
    address2,
    city,
    province,
    postalCode,
    individuallySet
  }
});

export const updateLivingSituation = (housingStatus, moveInDate) => ({
  type: "UPDATE_LIVING_SITUATION",
  payload: {
    housingStatus,
    moveInDate
  }
});



// WEBPACK FOOTER //
// ./src/actions/personalInfoAction.js